// eslint-disable-next-line
// @ts-nocheck
import React from 'react';
import { removeLeadingSlash } from '~/utils/removeLeadingSlash';

import { ModalProviderData } from '~/providers/modal-context';

interface IProps {
	context?: ModalProviderData;
	children?: any;
	childrenData?: any;
	className?: string;
	id?: string;
	marketAjaxUrl?: string;
	overrideFn?: (e: React.MouseEvent) => void;
	preCallback?: () => void;
	rel?: string;
	style?: string;
	target?: string;
	title?: string;
	to?: string;
	url?: string;
}

class Link extends React.Component<IProps> {
	public shouldComponentUpdate(nextProps: IProps) {
		return (
			this.props.childrenData !== nextProps.childrenData ||
			this.props.to !== nextProps.to ||
			this.props.className !== nextProps.className ||
			nextProps.childrenData === 'force'
		);
	}

	private generateBaseProps() {
		const {
			to: _to,
			overrideFn: _overrideFn,
			preCallback: _preCallback,
			dropdownOpen: _dropdownOpen,
			closeDropdown: _closeDropdown,
			childrenData: _childrenData,
			context: _context,
			...baseProps
		} = this.props;

		// NOTE: we only return the "to" prop
		// when there is no _childrenData
		return {
			to: !_childrenData ? _to : undefined,
			...baseProps,
		};
	}

	public render(): JSX.Element {
		const { id = '', to = '', children } = this.props;

		const baseProps = this.generateBaseProps();

		// Decode URL

		let decodedUrl = to || '';

		try {
			decodedUrl = decodeURIComponent(to || '');
		} catch (e) {
			console.error(e);
		}

		// Return span if insufficient payload data

		if (decodedUrl.endsWith('/us/undefined')) {
			return <span {...baseProps}>{children}</span>;
		}

		const linkId = id.replace(/ |-/g, '_');

		return (
			<a {...baseProps} id={linkId} href={removeLeadingSlash(to)}>
				{children}
			</a>
		);
	}
}

export default Link;
